<template>
    <v-container class="ma-0 pa-0">

        <v-row class="ma-0 pa-0">
            <v-col cols="12" class="ma-0 pa-0" align-self="start" align="left">
                <p class="cardio-title" v-html="getTitle" />
                <p class="desc" >
                    {{ getDescription }}
                </p>
            </v-col>
        </v-row>

        <v-row class="ma-0 pa-0">
            <v-col cols="12" class="ma-0 pa-0" align-self="start" align="center">
                <img
                    src="@/assets/images/img-exercise-walking.png"
                    class="iamge-cardio"
                    alt="유산소 운동"
                >
            </v-col>
        </v-row>

    </v-container>
</template>
<script>
    export default {
        data() {
            return {
            }
        },
        props: {
            isInsufficientExercise: {
                type: Boolean,
                required: true
            },
        },
        computed: {
            getTitle() {
                if(this.isInsufficientExercise) {
                    return this.$t('exerciseGuide.low.cardio.title')
                }
                else {
                    return this.$t('exerciseGuide.high.cardio.title')
                }
            },
            getDescription() {
                if(this.isInsufficientExercise) {
                    return this.$t('exerciseGuide.low.cardio.desc')
                }
                else {
                    return this.$t('exerciseGuide.high.cardio.desc')
                }
            },
        },
        mounted() {
        },
        methods: {
        }
    }
</script>
<style scoped>
    div {
        font-weight:bold;
    }
    .number {
        font-family: "NanumSquare", sans-serif;
        font-weight: bolder;
        font-size: 30px;
        margin-top: 20px;
        margin-bottom: 12px;
    }
    .cardio-title {
        font-family: "NanumSquare", sans-serif;
        font-weight: bolder;
        font-size: 18px;
        letter-spacing: -0.86px;
        color: #193263;
    }
    .desc {
        font-family: "NanumSquare", sans-serif;
        font-size: 14px;
        line-height: 24px;
        letter-spacing: -0.6px;
        color: #475b82;
    }
    .iamge-cardio {
        width: 100%;
    }
    .seperator {
        height: 1px;
        width: 100%;
        background-color: black;
        margin-bottom: 40px;
        opacity: 0.1;
    }
</style>
